import React from 'react'
import PropTypes from 'prop-types'
import AddCircle from '@mui/icons-material/AddCircle'

const AddCircleIcon = ({ height, width, ...more }) => {
	
	return (
		<AddCircle
			height={height}
			width={width}
			{...more}
		/>
	)
}

AddCircleIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default AddCircleIcon
